export const status = {
  UnAuthenticated: "UnAuthenticated",
  InSession: "InSession",
  IsAuthenticated: "IsAuthenticated",
  SessionDenied: "SessionDenied",
  LoginDenied: "LoginDenied",
  LoggedOut: "LoggedOut",
};
